module.exports = __webpack_public_path__ + "img/5-1.f52efa5f.svg";